/*!
 * © 2024. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For mor information visit: https://egtuniverse.com/legal
 *
 * Created for Universe App Tools.
 */
var _ = require("../../../uam/module.js")(module.exports, {
  namespace: "ua.toggle",
  title: "Toggle",
  description: "A themed on/off toggle control.",
  control: true,
  preview: "ua.preview.boolean",
  prevalidate: true,
  supportServer: false,
  fields: {
    "name": {
      title: "Name",
      type: "string",
      description: "The name of the control.",
      required: true
    },
    "title": {
      title: "Title",
      type: "string",
      description: "Label displayed next to the toggle.",
      required: true
    },
    "checked": {
      title: "Checked",
      type: "boolean",
      description: "Whether the toggle starts on.",
      default: false
    },
    "required": {
      title: "Required",
      type: "boolean",
      description: "Whether this control must be enabled.",
      default: false
    }
  },
  passthrough: {
    except: ["checked", "value", "type", "id"]
  }
});

var jsonRender = require("../interface/jsonRender.js");
var uai = require("../interface/interface.js");

exports.render = async function(options) {
  var randomName = uai.generateRandomID(24);
  var checked = !!(options.checked === true || options.value === true);

  var element = {
    n: "div",
    name: options.name,
    c: "form-group pb-3",
    i: [{
      n: "div",
      c: "form-check form-switch ua-toggle-control",
      i: [{
        n: "input",
        type: "checkbox",
        role: "switch",
        id: randomName,
        name: options.name,
        c: "form-check-input ua-toggle-input"
      }, {
        n: "label",
        c: "form-check-label",
        for: randomName,
        i: options.title || ""
      }]
    }]
  };

  if (checked) element.i[0].i[0].checked = true;
  if (options.required === true) element.i[0].i[0].required = true;

  return await jsonRender.render(element);
};

function validation(control) {
  var input = control.querySelector("input");
  var errors = [];
  if (!input) {
    errors.push({
      type: "validation",
      message: "Toggle input is missing."
    });
    return errors;
  }

  if (!input.checkValidity()) {
    errors.push({
      type: "validation",
      message: input.validationMessage
    });
  }

  return errors;
}

async function save(name, control, repo) {
  var input = control.querySelector("input");
  repo.errors = validation(control);
  repo.success = repo.errors.length === 0;
  repo.data = { checked: !!(input && input.checked) };
  return repo;
}

async function load(name, control, data) {
  var input = control.querySelector("input");
  if (!input) return;

  if (typeof data === "boolean") {
    input.checked = data;
    return;
  }

  if (data && typeof data === "object" && "checked" in data) {
    input.checked = !!data.checked;
    return;
  }

  input.checked = !!data;
}

module.exports.save = save;
module.exports.load = load;
